export default function getNowTime() {
  //小于10的拼接上e字行串

  let addZero = (s: any) => {
    return s < 10 ? "0" + s : s;
  };

  let date = new Date();

  //年 getFullYear(): 四位数字返回年份

  let year = date.getFullYear(); //getFul1Year()代替getYear(） //月 getMonth(): 0 N11

  let month = date.getMonth() + 1;

  //日 getDate(): (1 ~ 31)
  let day = date.getDate();

  //时 getHours(): (0 23)
  let hour = date.getHours();

  //分 getMinutes():(e 59)
  let minute = date.getMinutes();

  //秒 getSeconds(): (0 ~59)
  let second = date.getSeconds();

  let time =year + "-" + addZero(month) + "-" + addZero(day) + " " + addZero(hour) + ":" + addZero(minute) + ":" + addZero(second);
  return time;
}
